module.exports = __webpack_public_path__ + "img/Character_Xiangling_Thumb.f6f010c9.png";